import { ConfirmDialog, useToast } from "@nabble/ui";
import { requestPasswordReset } from "../../../../api/accountPassword";
import { errorMessage } from "../../../../errors";

/** Emails a one-time link to set a new password when the current one is forgotten. */
export function ForgotPasswordDialog({ open, email, onClose }: { open: boolean; email: string; onClose: () => void }): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={open}
      icon="mail"
      title="Set a new password by email"
      description={`We'll email a link to ${email} to set a new password. The link works once and expires in 1 hour.`}
      confirmLabel="Send link"
      onClose={onClose}
      onConfirm={async () => {
        try {
          await requestPasswordReset();
          onClose();
          show({ title: "Check your email", text: `We sent the link to ${email}.`, tone: "success" });
        } catch (err) {
          show({ title: "We couldn't send the link", text: errorMessage(err, "Please try again."), tone: "danger" });
        }
      }}
    />
  );
}
